import { Component, inject } from '@angular/core';
import { WorkTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WorkTypeCreateDto,
  WorkTypeDto,
  WorkTypeExcelDownloadDto,
  WorkTypeUpdateDto,
} from '../proxy/general/dtos/work-type';
import { WORKTYPE_CONFIG, WORKTYPE_FIELDS } from './work-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-work-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WorkTypeService, ConfirmationService],
  templateUrl: './work-type.html',
  styleUrl: './work-type.scss',
})
export class WorkType extends BaseCrudComponent<
  WorkTypeDto,
  WorkTypeCreateDto,
  WorkTypeUpdateDto,
  WorkTypeExcelDownloadDto
> {
  service = inject(WorkTypeService);
  config = WORKTYPE_CONFIG;
  fields = WORKTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: WorkTypeDto): WorkTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WorkType';
  }
}
